const $2100472b6a2d37bf$export$a5a6e0b888b2c992 = {
    clockShowSeconds: false,
    fireworkSettings: {
        hue: {
            min: 0,
            max: 345
        },
        acceleration: 1.05,
        brightness: {
            min: 50,
            max: 80
        },
        decay: {
            min: 0.015,
            max: 0.03
        },
        delay: {
            min: 30,
            max: 60
        },
        explosion: 5,
        flickering: 50,
        intensity: 30,
        friction: 0.97,
        gravity: 1.5,
        opacity: 0.5,
        particles: 60,
        traceLength: 3,
        traceSpeed: 10,
        rocketsPoint: {
            min: 50,
            max: 50
        },
        lineWidth: {
            explosion: {
                min: 1,
                max: 4
            },
            trace: {
                min: 0.1,
                max: 1
            }
        },
        lineStyle: 'round'
    }
};


if (typeof (0, $2100472b6a2d37bf$export$a5a6e0b888b2c992) === 'undefined') console.log('ERROR HERE');
const $a2b1af726bc05dc6$var$canvas = document.getElementById("canvas");
//const p = document.getElementById("time");
const $a2b1af726bc05dc6$var$ctx = $a2b1af726bc05dc6$var$canvas.getContext("2d");
let $a2b1af726bc05dc6$var$radius = $a2b1af726bc05dc6$var$canvas.height / 2;
$a2b1af726bc05dc6$var$ctx.translate($a2b1af726bc05dc6$var$radius, $a2b1af726bc05dc6$var$radius);
$a2b1af726bc05dc6$var$radius = $a2b1af726bc05dc6$var$radius * 0.90;
function $a2b1af726bc05dc6$export$4a17d052f4e372b2(h = null, m = null, s = null, type) {
    switch(type){
        case 'digital':
            $a2b1af726bc05dc6$var$drawDigital(h, m);
            break;
        default:
            $a2b1af726bc05dc6$var$drawFace($a2b1af726bc05dc6$var$ctx, $a2b1af726bc05dc6$var$radius);
            $a2b1af726bc05dc6$var$drawNumbers($a2b1af726bc05dc6$var$ctx, $a2b1af726bc05dc6$var$radius);
            $a2b1af726bc05dc6$var$drawTime($a2b1af726bc05dc6$var$ctx, $a2b1af726bc05dc6$var$radius, h, m, s);
            break;
    }
}
function $a2b1af726bc05dc6$var$drawDigital(h, m) {
    // https://freefrontend.com/javascript-clocks/
    let digitalFont = new FontFace(//"Orbitron",
    // "url(https://fonts.gstatic.com/s/orbitron/v35/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyGy6BoWgz.woff2)"
    "Seven Segment", 'url("https://fonts.cdnfonts.com/s/71640/Seven Segment.woff")');
    digitalFont.load().then((font)=>{
        h = h < 10 ? "0" + h : h;
        m = m < 10 ? "0" + m : m;
        document.fonts.add(font);
        $a2b1af726bc05dc6$var$ctx.font = "120px Seven Segment";
        $a2b1af726bc05dc6$var$ctx.fillStyle = '#095666ff';
        $a2b1af726bc05dc6$var$ctx.translate(-($a2b1af726bc05dc6$var$canvas.width / 3), 0);
        $a2b1af726bc05dc6$var$ctx.fillText(h + ':' + m, 0, 0);
    });
//ctx.transform(-0.5, -0.5, 0, 0, 0, 0);
}
function $a2b1af726bc05dc6$var$drawFace(ctx, radius) {
    const grad = ctx.createRadialGradient(0, 0, radius * 0.95, 0, 0, radius * 1.05);
    grad.addColorStop(0, '#333');
    grad.addColorStop(0.5, 'white');
    grad.addColorStop(1, '#333');
    ctx.beginPath();
    ctx.arc(0, 0, radius, 0, 2 * Math.PI);
    ctx.fillStyle = 'white';
    ctx.fill();
    ctx.strokeStyle = grad;
    ctx.lineWidth = radius * 0.1;
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.1, 0, 2 * Math.PI);
    ctx.fillStyle = '#333';
    ctx.fill();
}
function $a2b1af726bc05dc6$var$drawNumbers(ctx, radius) {
    ctx.font = radius * 0.14 + "px arial";
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";
    for(let num = 1; num < 13; num++){
        let ang = num * Math.PI / 6;
        ctx.rotate(ang);
        ctx.translate(0, -radius * 0.85);
        ctx.rotate(-ang);
        ctx.fillText(num.toString(), 0, 0);
        ctx.rotate(ang);
        ctx.translate(0, radius * 0.85);
        ctx.rotate(-ang);
    }
    ctx.font = radius * 0.14 + "px arial";
    for(let tick = 0; tick < 60; tick++){
        //skip if number
        if (tick % 5 == 0) continue;
        let ang = tick * Math.PI / 30;
        ctx.rotate(ang);
        ctx.translate(0, -radius * 0.86);
        ctx.rotate(-ang);
        ctx.fillText(String.fromCharCode(parseInt('00B7', 16)), 0, 0);
        ctx.rotate(ang);
        ctx.translate(0, radius * 0.86);
        ctx.rotate(-ang);
    }
}
function $a2b1af726bc05dc6$var$drawTime(ctx, radius, h, m, s) {
    const now = new Date();
    let hour = h ?? now.getHours();
    let minute = m ?? now.getMinutes();
    let second = s ?? now.getSeconds();
    //printTime(hour, minute, second); //nrb
    //hour
    hour = hour % 12;
    hour = hour * Math.PI / 6 + minute * Math.PI / 360 + second * Math.PI / 21600;
    $a2b1af726bc05dc6$var$drawHand(ctx, hour, radius * 0.5, radius * 0.07);
    //minute
    minute = minute * Math.PI / 30 + second * Math.PI / 1800;
    $a2b1af726bc05dc6$var$drawHand(ctx, minute, radius * 0.8, radius * 0.07);
    // second
    if ((0, $2100472b6a2d37bf$export$a5a6e0b888b2c992).clockShowSeconds) {
        second = second * Math.PI / 30;
        $a2b1af726bc05dc6$var$drawHand(ctx, second, radius * 0.9, radius * 0.02);
    }
}
function $a2b1af726bc05dc6$var$drawHand(ctx, pos, length, width) {
    ctx.beginPath();
    ctx.lineWidth = width;
    ctx.lineCap = "round";
    ctx.moveTo(0, 0);
    ctx.rotate(pos);
    ctx.lineTo(0, -length);
    ctx.stroke();
    ctx.rotate(-pos);
}


/**
 * name: fireworks-js
 * version: 2.10.8
 * author: Vitalij Ryndin (https://crashmax.ru)
 * homepage: https://fireworks.js.org
 * license MIT
 */ function $6a3b0ccbba9d35fe$var$f(e) {
    return Math.abs(Math.floor(e));
}
function $6a3b0ccbba9d35fe$var$c(e, t) {
    return Math.random() * (t - e) + e;
}
function $6a3b0ccbba9d35fe$var$o(e, t) {
    return Math.floor($6a3b0ccbba9d35fe$var$c(e, t + 1));
}
function $6a3b0ccbba9d35fe$var$m(e, t, i, s) {
    const n = Math.pow;
    return Math.sqrt(n(e - i, 2) + n(t - s, 2));
}
function $6a3b0ccbba9d35fe$var$x(e, t, i = 1) {
    if (e > 360 || e < 0) throw new Error(`Expected hue 0-360 range, got \`${e}\``);
    if (t > 100 || t < 0) throw new Error(`Expected lightness 0-100 range, got \`${t}\``);
    if (i > 1 || i < 0) throw new Error(`Expected alpha 0-1 range, got \`${i}\``);
    return `hsla(${e}, 100%, ${t}%, ${i})`;
}
const $6a3b0ccbba9d35fe$var$g = (e)=>{
    if (typeof e == "object" && e !== null) {
        if (typeof Object.getPrototypeOf == "function") {
            const t = Object.getPrototypeOf(e);
            return t === Object.prototype || t === null;
        }
        return Object.prototype.toString.call(e) === "[object Object]";
    }
    return !1;
}, $6a3b0ccbba9d35fe$var$y = [
    "__proto__",
    "constructor",
    "prototype"
], $6a3b0ccbba9d35fe$var$v = (...e)=>e.reduce((t, i)=>(Object.keys(i).forEach((s)=>{
            $6a3b0ccbba9d35fe$var$y.includes(s) || (Array.isArray(t[s]) && Array.isArray(i[s]) ? t[s] = i[s] : $6a3b0ccbba9d35fe$var$g(t[s]) && $6a3b0ccbba9d35fe$var$g(i[s]) ? t[s] = $6a3b0ccbba9d35fe$var$v(t[s], i[s]) : t[s] = i[s]);
        }), t), {});
function $6a3b0ccbba9d35fe$var$b(e, t) {
    let i;
    return (...s)=>{
        i && clearTimeout(i), i = setTimeout(()=>e(...s), t);
    };
}
class $6a3b0ccbba9d35fe$var$S {
    x;
    y;
    ctx;
    hue;
    friction;
    gravity;
    flickering;
    lineWidth;
    explosionLength;
    angle;
    speed;
    brightness;
    coordinates = [];
    decay;
    alpha = 1;
    constructor({ x: t, y: i, ctx: s, hue: n, decay: h, gravity: a, friction: r, brightness: u, flickering: p, lineWidth: l, explosionLength: d }){
        for(this.x = t, this.y = i, this.ctx = s, this.hue = n, this.gravity = a, this.friction = r, this.flickering = p, this.lineWidth = l, this.explosionLength = d, this.angle = $6a3b0ccbba9d35fe$var$c(0, Math.PI * 2), this.speed = $6a3b0ccbba9d35fe$var$o(1, 10), this.brightness = $6a3b0ccbba9d35fe$var$o(u.min, u.max), this.decay = $6a3b0ccbba9d35fe$var$c(h.min, h.max); this.explosionLength--;)this.coordinates.push([
            t,
            i
        ]);
    }
    update(t) {
        this.coordinates.pop(), this.coordinates.unshift([
            this.x,
            this.y
        ]), this.speed *= this.friction, this.x += Math.cos(this.angle) * this.speed, this.y += Math.sin(this.angle) * this.speed + this.gravity, this.alpha -= this.decay, this.alpha <= this.decay && t();
    }
    draw() {
        const t = this.coordinates.length - 1;
        this.ctx.beginPath(), this.ctx.lineWidth = this.lineWidth, this.ctx.fillStyle = $6a3b0ccbba9d35fe$var$x(this.hue, this.brightness, this.alpha), this.ctx.moveTo(this.coordinates[t][0], this.coordinates[t][1]), this.ctx.lineTo(this.x, this.y), this.ctx.strokeStyle = $6a3b0ccbba9d35fe$var$x(this.hue, this.flickering ? $6a3b0ccbba9d35fe$var$c(0, this.brightness) : this.brightness, this.alpha), this.ctx.stroke();
    }
}
class $6a3b0ccbba9d35fe$var$E {
    constructor(t, i){
        this.options = t, this.canvas = i, this.pointerDown = this.pointerDown.bind(this), this.pointerUp = this.pointerUp.bind(this), this.pointerMove = this.pointerMove.bind(this);
    }
    active = !1;
    x;
    y;
    get mouseOptions() {
        return this.options.mouse;
    }
    mount() {
        this.canvas.addEventListener("pointerdown", this.pointerDown), this.canvas.addEventListener("pointerup", this.pointerUp), this.canvas.addEventListener("pointermove", this.pointerMove);
    }
    unmount() {
        this.canvas.removeEventListener("pointerdown", this.pointerDown), this.canvas.removeEventListener("pointerup", this.pointerUp), this.canvas.removeEventListener("pointermove", this.pointerMove);
    }
    usePointer(t, i) {
        const { click: s, move: n } = this.mouseOptions;
        (s || n) && (this.x = t.pageX - this.canvas.offsetLeft, this.y = t.pageY - this.canvas.offsetTop, this.active = i);
    }
    pointerDown(t) {
        this.usePointer(t, this.mouseOptions.click);
    }
    pointerUp(t) {
        this.usePointer(t, !1);
    }
    pointerMove(t) {
        this.usePointer(t, this.active);
    }
}
class $6a3b0ccbba9d35fe$var$O {
    hue;
    rocketsPoint;
    opacity;
    acceleration;
    friction;
    gravity;
    particles;
    explosion;
    mouse;
    boundaries;
    sound;
    delay;
    brightness;
    decay;
    flickering;
    intensity;
    traceLength;
    traceSpeed;
    lineWidth;
    lineStyle;
    autoresize;
    constructor(){
        this.autoresize = !0, this.lineStyle = "round", this.flickering = 50, this.traceLength = 3, this.traceSpeed = 10, this.intensity = 30, this.explosion = 5, this.gravity = 1.5, this.opacity = 0.5, this.particles = 50, this.friction = 0.95, this.acceleration = 1.05, this.hue = {
            min: 0,
            max: 360
        }, this.rocketsPoint = {
            min: 50,
            max: 50
        }, this.lineWidth = {
            explosion: {
                min: 1,
                max: 3
            },
            trace: {
                min: 1,
                max: 2
            }
        }, this.mouse = {
            click: !1,
            move: !1,
            max: 1
        }, this.delay = {
            min: 30,
            max: 60
        }, this.brightness = {
            min: 50,
            max: 80
        }, this.decay = {
            min: 0.015,
            max: 0.03
        }, this.sound = {
            enabled: !1,
            files: [
                "explosion0.mp3",
                "explosion1.mp3",
                "explosion2.mp3"
            ],
            volume: {
                min: 4,
                max: 8
            }
        }, this.boundaries = {
            debug: !1,
            height: 0,
            width: 0,
            x: 50,
            y: 50
        };
    }
    update(t) {
        Object.assign(this, $6a3b0ccbba9d35fe$var$v(this, t));
    }
}
class $6a3b0ccbba9d35fe$var$z {
    constructor(t, i){
        this.options = t, this.render = i;
    }
    tick = 0;
    rafId = 0;
    fps = 60;
    tolerance = 0.1;
    now;
    mount() {
        this.now = performance.now();
        const t = 1e3 / this.fps, i = (s)=>{
            this.rafId = requestAnimationFrame(i);
            const n = s - this.now;
            n >= t - this.tolerance && (this.render(), this.now = s - n % t, this.tick += n * (this.options.intensity * Math.PI) / 1e3);
        };
        this.rafId = requestAnimationFrame(i);
    }
    unmount() {
        cancelAnimationFrame(this.rafId);
    }
}
class $6a3b0ccbba9d35fe$var$L {
    constructor(t, i, s){
        this.options = t, this.updateSize = i, this.container = s;
    }
    resizer;
    mount() {
        if (!this.resizer) {
            const t = $6a3b0ccbba9d35fe$var$b(()=>this.updateSize(), 100);
            this.resizer = new ResizeObserver(t);
        }
        this.options.autoresize && this.resizer.observe(this.container);
    }
    unmount() {
        this.resizer && this.resizer.unobserve(this.container);
    }
}
class $6a3b0ccbba9d35fe$var$M {
    constructor(t){
        this.options = t, this.init();
    }
    buffers = [];
    audioContext;
    onInit = !1;
    get isEnabled() {
        return this.options.sound.enabled;
    }
    get soundOptions() {
        return this.options.sound;
    }
    init() {
        !this.onInit && this.isEnabled && (this.onInit = !0, this.audioContext = new (window.AudioContext || window.webkitAudioContext)(), this.loadSounds());
    }
    async loadSounds() {
        for (const t of this.soundOptions.files){
            const i = await (await fetch(t)).arrayBuffer();
            this.audioContext.decodeAudioData(i).then((s)=>{
                this.buffers.push(s);
            }).catch((s)=>{
                throw s;
            });
        }
    }
    play() {
        if (this.isEnabled && this.buffers.length) {
            const t = this.audioContext.createBufferSource(), i = this.buffers[$6a3b0ccbba9d35fe$var$o(0, this.buffers.length - 1)], s = this.audioContext.createGain();
            t.buffer = i, s.gain.value = $6a3b0ccbba9d35fe$var$c(this.soundOptions.volume.min / 100, this.soundOptions.volume.max / 100), s.connect(this.audioContext.destination), t.connect(s), t.start(0);
        } else this.init();
    }
}
class $6a3b0ccbba9d35fe$var$C {
    x;
    y;
    sx;
    sy;
    dx;
    dy;
    ctx;
    hue;
    speed;
    acceleration;
    traceLength;
    totalDistance;
    angle;
    brightness;
    coordinates = [];
    currentDistance = 0;
    constructor({ x: t, y: i, dx: s, dy: n, ctx: h, hue: a, speed: r, traceLength: u, acceleration: p }){
        for(this.x = t, this.y = i, this.sx = t, this.sy = i, this.dx = s, this.dy = n, this.ctx = h, this.hue = a, this.speed = r, this.traceLength = u, this.acceleration = p, this.totalDistance = $6a3b0ccbba9d35fe$var$m(t, i, s, n), this.angle = Math.atan2(n - i, s - t), this.brightness = $6a3b0ccbba9d35fe$var$o(50, 70); this.traceLength--;)this.coordinates.push([
            t,
            i
        ]);
    }
    update(t) {
        this.coordinates.pop(), this.coordinates.unshift([
            this.x,
            this.y
        ]), this.speed *= this.acceleration;
        const i = Math.cos(this.angle) * this.speed, s = Math.sin(this.angle) * this.speed;
        this.currentDistance = $6a3b0ccbba9d35fe$var$m(this.sx, this.sy, this.x + i, this.y + s), this.currentDistance >= this.totalDistance ? t(this.dx, this.dy, this.hue) : (this.x += i, this.y += s);
    }
    draw() {
        const t = this.coordinates.length - 1;
        this.ctx.beginPath(), this.ctx.moveTo(this.coordinates[t][0], this.coordinates[t][1]), this.ctx.lineTo(this.x, this.y), this.ctx.strokeStyle = $6a3b0ccbba9d35fe$var$x(this.hue, this.brightness), this.ctx.stroke();
    }
}
class $6a3b0ccbba9d35fe$export$cf4b77f9e070dc2c {
    target;
    container;
    canvas;
    ctx;
    width;
    height;
    traces = [];
    explosions = [];
    waitStopRaf;
    running = !1;
    opts;
    sound;
    resize;
    mouse;
    raf;
    constructor(t, i = {}){
        this.target = t, this.container = t, this.opts = new $6a3b0ccbba9d35fe$var$O(), this.createCanvas(this.target), this.updateOptions(i), this.sound = new $6a3b0ccbba9d35fe$var$M(this.opts), this.resize = new $6a3b0ccbba9d35fe$var$L(this.opts, this.updateSize.bind(this), this.container), this.mouse = new $6a3b0ccbba9d35fe$var$E(this.opts, this.canvas), this.raf = new $6a3b0ccbba9d35fe$var$z(this.opts, this.render.bind(this));
    }
    get isRunning() {
        return this.running;
    }
    get version() {
        return "2.10.8";
    }
    get currentOptions() {
        return this.opts;
    }
    start() {
        this.running || (this.canvas.isConnected || this.createCanvas(this.target), this.running = !0, this.resize.mount(), this.mouse.mount(), this.raf.mount());
    }
    stop(t = !1) {
        this.running && (this.running = !1, this.resize.unmount(), this.mouse.unmount(), this.raf.unmount(), this.clear(), t && this.canvas.remove());
    }
    async waitStop(t) {
        if (this.running) return new Promise((i)=>{
            this.waitStopRaf = ()=>{
                this.waitStopRaf && (requestAnimationFrame(this.waitStopRaf), !this.traces.length && !this.explosions.length && (this.waitStopRaf = null, this.stop(t), i()));
            }, this.waitStopRaf();
        });
    }
    pause() {
        this.running = !this.running, this.running ? this.raf.mount() : this.raf.unmount();
    }
    clear() {
        this.ctx && (this.traces = [], this.explosions = [], this.ctx.clearRect(0, 0, this.width, this.height));
    }
    launch(t = 1) {
        for(let i = 0; i < t; i++)this.createTrace();
        this.waitStopRaf || (this.start(), this.waitStop());
    }
    updateOptions(t) {
        this.opts.update(t);
    }
    updateSize({ width: t = this.container.clientWidth, height: i = this.container.clientHeight } = {}) {
        this.width = t, this.height = i, this.canvas.width = t, this.canvas.height = i, this.updateBoundaries({
            ...this.opts.boundaries,
            width: t,
            height: i
        });
    }
    updateBoundaries(t) {
        this.updateOptions({
            boundaries: t
        });
    }
    createCanvas(t) {
        t instanceof HTMLCanvasElement ? (t.isConnected || document.body.append(t), this.canvas = t) : (this.canvas = document.createElement("canvas"), this.container.append(this.canvas)), this.ctx = this.canvas.getContext("2d"), this.updateSize();
    }
    render() {
        if (!this.ctx || !this.running) return;
        const { opacity: t, lineStyle: i, lineWidth: s } = this.opts;
        this.ctx.globalCompositeOperation = "destination-out", this.ctx.fillStyle = `rgba(0, 0, 0, ${t})`, this.ctx.fillRect(0, 0, this.width, this.height), this.ctx.globalCompositeOperation = "lighter", this.ctx.lineCap = i, this.ctx.lineJoin = "round", this.ctx.lineWidth = $6a3b0ccbba9d35fe$var$c(s.trace.min, s.trace.max), this.initTrace(), this.drawTrace(), this.drawExplosion();
    }
    createTrace() {
        const { hue: t, rocketsPoint: i, boundaries: s, traceLength: n, traceSpeed: h, acceleration: a, mouse: r } = this.opts;
        this.traces.push(new $6a3b0ccbba9d35fe$var$C({
            x: this.width * $6a3b0ccbba9d35fe$var$o(i.min, i.max) / 100,
            y: this.height,
            dx: this.mouse.x && r.move || this.mouse.active ? this.mouse.x : $6a3b0ccbba9d35fe$var$o(s.x, s.width - s.x * 2),
            dy: this.mouse.y && r.move || this.mouse.active ? this.mouse.y : $6a3b0ccbba9d35fe$var$o(s.y, s.height * 0.5),
            ctx: this.ctx,
            hue: $6a3b0ccbba9d35fe$var$o(t.min, t.max),
            speed: h,
            acceleration: a,
            traceLength: $6a3b0ccbba9d35fe$var$f(n)
        }));
    }
    initTrace() {
        if (this.waitStopRaf) return;
        const { delay: t, mouse: i } = this.opts;
        (this.raf.tick > $6a3b0ccbba9d35fe$var$o(t.min, t.max) || this.mouse.active && i.max > this.traces.length) && (this.createTrace(), this.raf.tick = 0);
    }
    drawTrace() {
        let t = this.traces.length;
        for(; t--;)this.traces[t].draw(), this.traces[t].update((i, s, n)=>{
            this.initExplosion(i, s, n), this.sound.play(), this.traces.splice(t, 1);
        });
    }
    initExplosion(t, i, s) {
        const { particles: n, flickering: h, lineWidth: a, explosion: r, brightness: u, friction: p, gravity: l, decay: d } = this.opts;
        let w = $6a3b0ccbba9d35fe$var$f(n);
        for(; w--;)this.explosions.push(new $6a3b0ccbba9d35fe$var$S({
            x: t,
            y: i,
            ctx: this.ctx,
            hue: s,
            friction: p,
            gravity: l,
            flickering: $6a3b0ccbba9d35fe$var$o(0, 100) <= h,
            lineWidth: $6a3b0ccbba9d35fe$var$c(a.explosion.min, a.explosion.max),
            explosionLength: $6a3b0ccbba9d35fe$var$f(r),
            brightness: u,
            decay: d
        }));
    }
    drawExplosion() {
        let t = this.explosions.length;
        for(; t--;)this.explosions[t].draw(), this.explosions[t].update(()=>{
            this.explosions.splice(t, 1);
        });
    }
}


//import Cookies from "js-cookie";

const $3555ff9e1e0fa800$var$scoreCorrect = document.getElementById("score_correct");
const $3555ff9e1e0fa800$var$scoreTotal = document.getElementById("score_total");
const $3555ff9e1e0fa800$var$levelSlider = document.getElementById("level_slider");
const $3555ff9e1e0fa800$var$levelIcons = document.getElementsByClassName("level-icon");
$3555ff9e1e0fa800$var$levelSlider.oninput = function() {
    //Cookies.set('level', this.value, { sameSite: 'strict' });
    window.localStorage.setItem('level', this.value);
    (0, $fcd6031be73b1372$export$2d6e9b4c68afb6c8)();
};
function $3555ff9e1e0fa800$export$e94bc884182bf321() {
    let current = parseInt($3555ff9e1e0fa800$var$scoreTotal.innerText);
    $3555ff9e1e0fa800$var$scoreTotal.innerText = current + 1;
}
function $3555ff9e1e0fa800$export$1ec73c154f165e75() {
    let current = parseInt($3555ff9e1e0fa800$var$scoreCorrect.innerText);
    $3555ff9e1e0fa800$var$scoreCorrect.innerText = current + 1;
    //document.cookie = "correct=" + (current + 1);
    // {expires: 1/24} = 1 time
    //Cookies.set('correct', current + 1, { sameSite: 'strict' });
    window.sessionStorage.setItem('score', current + 1);
// incTotal();
}
function $3555ff9e1e0fa800$export$bed6ab87e2e89fc() {
    //let score = Cookies.get('correct');
    let score = window.sessionStorage.getItem('score');
    $3555ff9e1e0fa800$var$scoreCorrect.innerText = score ?? '0';
//return parseInt(scoreCorrect.innerText);
}
function $3555ff9e1e0fa800$export$bbb5699fb5728e4f() {
    //let level = Cookies.get('level');
    let level = window.localStorage.getItem('level');
    $3555ff9e1e0fa800$var$levelSlider.value = level ?? '1';
    let levelInt = parseInt($3555ff9e1e0fa800$var$levelSlider.value);
    $3555ff9e1e0fa800$var$levelIcons[levelInt - 1].style.display = 'block';
    return levelInt;
}




//DECLARE HTML CLASS, ID, TAG VARIABLES
const $d560f046f37f5b87$var$destinationContainer = document.getElementById("destination__container");
const $d560f046f37f5b87$var$originContainer = document.getElementById("origin__container");
const $d560f046f37f5b87$var$words = document.getElementsByClassName("word");
const $d560f046f37f5b87$var$checkButton = document.getElementById("check_button");
let $d560f046f37f5b87$var$destinationPosDefault = $d560f046f37f5b87$var$destinationContainer.getBoundingClientRect();
//DECLARE CODE VARIABLES
//store coordinates of the words by order of their placement.
let $d560f046f37f5b87$var$destinationArray = [];
//store coordinates of the words in the origin array
const $d560f046f37f5b87$var$originArray = [];
function $d560f046f37f5b87$export$34d72cd9c2e466e5(solution, wrong, callback) {
    $d560f046f37f5b87$var$printWords(solution, wrong);
    $d560f046f37f5b87$var$animateButtons();
    $d560f046f37f5b87$var$checkButtonClick(solution, callback);
}
function $d560f046f37f5b87$var$shuffle(arr) {
    let i = arr.length, j, temp;
    while(--i > 0){
        j = Math.floor(Math.random() * (i + 1));
        temp = arr[j];
        arr[j] = arr[i];
        arr[i] = temp;
    }
    return arr;
}
//Print the list of words   **
function $d560f046f37f5b87$var$printWords(solution, wrong) {
    const arr = [
        ...solution.flat(),
        ...wrong
    ];
    const listOfWords = $d560f046f37f5b87$var$shuffle(arr);
    for(let i = 0; i < listOfWords.length; i++){
        if (listOfWords[i] == 0) continue;
        const wordNode = document.createElement("div");
        wordNode.textContent = listOfWords[i];
        wordNode.classList.add("word");
        $d560f046f37f5b87$var$originContainer.appendChild(wordNode);
    }
}
function $d560f046f37f5b87$var$calibrateDestinationCursorPos(destinationArray) {
    //When no word is clicked on
    if (destinationArray.length === 0) return $d560f046f37f5b87$var$destinationPosDefault.x;
    else {
        //if word is placed in the destination, fetch coordinates of last word
        //as starting point for the next word.
        let sum = $d560f046f37f5b87$var$destinationPosDefault.x;
        destinationArray.forEach((element)=>{
            sum += element.width + 20; //add 20px for the spacing
        });
        return sum;
    }
}
function $d560f046f37f5b87$export$af5275a7b615dadd() {
    // animate buttons back to original position
    [
        ...$d560f046f37f5b87$var$originContainer.children
    ].forEach((e)=>e.style = '');
    // update location of buttons
    $d560f046f37f5b87$var$originArray.forEach((e)=>e.location = "origin");
    // clear destinationArray
    $d560f046f37f5b87$var$destinationArray.length = 0;
}
function $d560f046f37f5b87$var$createOriginArray(word) {
    let wordPosition = word.getBoundingClientRect();
    let newWordObject = Object.assign(wordPosition);
    newWordObject.word = word.textContent;
    newWordObject.location = "origin";
    $d560f046f37f5b87$var$originArray.push(newWordObject);
}
function $d560f046f37f5b87$var$animateButtons() {
    for(let i = 0; i < $d560f046f37f5b87$var$words.length; i++){
        $d560f046f37f5b87$var$createOriginArray($d560f046f37f5b87$var$words[i]);
        $d560f046f37f5b87$var$words[i].addEventListener("click", ()=>{
            //Check de destinationStartPos
            let destinationStartPos = $d560f046f37f5b87$var$calibrateDestinationCursorPos($d560f046f37f5b87$var$destinationArray);
            //Calculate X and Y distance between destination and the word
            let yTravel = $d560f046f37f5b87$var$originArray[i].y - ($d560f046f37f5b87$var$destinationPosDefault.y + ($d560f046f37f5b87$var$destinationPosDefault.height - $d560f046f37f5b87$var$originArray[i].height) / 2);
            let xTravel = 0;
            if ($d560f046f37f5b87$var$originArray[i].x > destinationStartPos) xTravel = -($d560f046f37f5b87$var$originArray[i].x - destinationStartPos);
            else xTravel = destinationStartPos - $d560f046f37f5b87$var$originArray[i].x;
            if ($d560f046f37f5b87$var$originArray[i].location === "origin") {
                $d560f046f37f5b87$var$originArray[i].location = "destination";
                //Put the word object in the destination array
                $d560f046f37f5b87$var$destinationArray.push($d560f046f37f5b87$var$originArray[i]);
            } else if ($d560f046f37f5b87$var$originArray[i].location === "destination") {
                yTravel = 0;
                xTravel = 0;
                $d560f046f37f5b87$var$originArray[i].location = "origin";
                //delete the word from the destination Array
                let test = $d560f046f37f5b87$var$destinationArray.filter((wordObject)=>wordObject.word !== $d560f046f37f5b87$var$originArray[i].word);
                $d560f046f37f5b87$var$destinationArray = test;
            }
            //Apply translate
            $d560f046f37f5b87$var$words[i].style.transform = `translate(${xTravel}px,-${yTravel}px)`;
        });
    }
}
function $d560f046f37f5b87$var$checkButtonClick(arr, callback) {
    $d560f046f37f5b87$var$checkButton.addEventListener("click", ()=>{
        let answer = $d560f046f37f5b87$var$destinationArray.map((e)=>{
            return e['word'];
        });
        callback(arr, answer);
    //console.log('solution is ' + arr);
    //console.log('answer is ' + answer);
    //console.log(compareArrays(answer, arr))
    });
}



//import Cookies from "js-cookie";
var $5832402495609784$var$result = false;
function $5832402495609784$var$getRandomTime(fiveMinutesInterval = false) {
    const hours = Math.floor(Math.random() * 12) + 1;
    const minutesArray = [
        5,
        10,
        15,
        20,
        25
    ];
    const minutes = fiveMinutesInterval ? minutesArray[Math.floor(Math.random() * minutesArray.length)] : //Math.floor(Math.random() * 58) + 1;
    Math.floor(Math.random() * 28) + 1;
    return {
        h: hours,
        m: minutes
    };
}
function $5832402495609784$var$getRandomMinutes(notArray = []) {
    let rnd = Math.floor(Math.random() * 28) + 1;
    return notArray.includes(rnd) ? $5832402495609784$var$getRandomMinutes(notArray) : rnd;
}
function $5832402495609784$var$makeWrongMinutes(m, difficulty) {
    if (difficulty.fiveMinutesInterval) return [
        m < 25 ? (m + 5).toString() : 5..toString(),
        m == 5 ? 5..toString() : (m - 5).toString()
    ];
    else {
        let first = $5832402495609784$var$getRandomMinutes([
            m
        ]);
        let second = $5832402495609784$var$getRandomMinutes([
            m,
            first
        ]);
        return [
            first.toString(),
            second.toString()
        ];
    }
}
function $5832402495609784$var$challengeType() {
    /* prevent same consecutive type and types 0 and 1 following */ let type = Math.floor(Math.random() * 4);
    //let lastType = parseInt( Cookies.get('lastType') );
    let lastType = parseInt(window.sessionStorage.getItem('lastType'));
    return type === lastType || type + lastType === 1 ? $5832402495609784$var$challengeType() : //Cookies.set('lastType', type, { sameSite: 'strict' }), type);
    (window.sessionStorage.setItem('lastType', type), type);
}
function $5832402495609784$export$4e9f46eab2f1407a(difficulty) {
    /**
     * return arr[minutes, hours, solution]
     */ /*
    types:
        0: klokken hel
        1: klokken halv
        2: x minutter over
        3: x minutter i
    */ //const type = Math.floor(Math.random() * 4);
    const type = $5832402495609784$var$challengeType();
    console.log('type: ' + type);
    const time = $5832402495609784$var$getRandomTime(difficulty.fiveMinutesInterval);
    const h1 = time.h;
    const m = time.m;
    switch(type){
        case 0:
            return {
                m: 0,
                h: h1,
                solution: [
                    h1.toString()
                ],
                wrong: [
                    'halv',
                    '12',
                    h1 < 12 ? (h1 + 1).toString() : 1..toString(),
                    h1 == 1 ? 12..toString() : (h1 - 1).toString()
                ]
            };
        case 1:
            return {
                m: 30,
                h: h1,
                solution: [
                    'halv',
                    h1 < 12 ? (h1 + 1).toString() : 1..toString()
                ],
                wrong: [
                    '6',
                    h1 < 12 ? h1.toString() : 1..toString(),
                    h1 == 1 ? 12..toString() : (h1 - 1).toString()
                ]
            };
        case 2:
            return {
                m: m,
                h: h1,
                solution: [
                    m.toString(),
                    'minutter over',
                    h1.toString()
                ],
                wrong: [
                    'minutter i',
                    h1 < 12 ? (h1 + 1).toString() : 1..toString(),
                    h1 == 1 ? 12..toString() : (h1 - 1).toString(),
                    ...$5832402495609784$var$makeWrongMinutes(m, difficulty)
                ]
            };
        case 3:
            return {
                //m: m + 30,
                m: 60 - m,
                h: h1,
                solution: [
                    //Math.abs(m - 30).toString(),
                    m.toString(),
                    'minutter i',
                    h1 < 12 ? (h1 + 1).toString() : 1..toString()
                ],
                wrong: [
                    'minutter over',
                    h1 < 12 ? h1.toString() : 1..toString(),
                    h1 == 1 ? 12..toString() : (h1 - 1).toString(),
                    ...$5832402495609784$var$makeWrongMinutes(m, difficulty)
                ]
            };
        default:
            console.log("Error in challenge.js");
            break;
    }
}
function $5832402495609784$export$e230fdca65f21805(solution, answer) {
    let correct = solution.length === answer.length && solution.every((element, index)=>element === answer[index]);
    //console.log(solution, answer)
    //console.log(correct);
    $5832402495609784$var$result = correct;
    /* fireworks */ if (correct) {
        (0, $3555ff9e1e0fa800$export$1ec73c154f165e75)();
        const svg = document.querySelector('#trophy');
        svg.classList.add('svg_animate');
        const container = document.getElementById('fireworks');
        container.style.zIndex = 1000; /* test. may cause problems */ 
        const fireworks = new (0, $6a3b0ccbba9d35fe$export$cf4b77f9e070dc2c)(container, (0, $2100472b6a2d37bf$export$a5a6e0b888b2c992).fireworkSettings);
        const numberOfRockets = container.clientWidth > 1024 ? 20 : 10;
        fireworks.launch(numberOfRockets);
        //fireworks.start();
        setTimeout((0, $fcd6031be73b1372$export$2d6e9b4c68afb6c8), 2000);
    } else {
        // incTotal();
        const container = document.getElementById('canvas');
        container.classList.add('error_animate');
        setTimeout(()=>container.classList.remove('error_animate'), 1000);
        (0, $d560f046f37f5b87$export$af5275a7b615dadd)();
    }
}
function $5832402495609784$export$ec795fdf61e2a255() {
    return $5832402495609784$var$result;
}
function $5832402495609784$var$r() {
    h = Math.floor(Math.random() * 12) + 1;
    console.log('h is: ' + h);
    hh = h < 12 ? h + 1 : 1;
    console.log('hh is: ' + hh);
} /*
switch (Math.floor(Math.random() * 4)) {
        case 0:
            console.log("type 0");
            return [
                0, h, 
                [h.toString()]
            ];
        
        case 1:
            console.log("type 1");
            return [
                30, h, 
                [
                    ['30', 'minutter over', h.toString()],
                    ['halv', (h < 12) ? (h + 1).toString() : (1).toString() ]
                ]
            ];

        case 2:
            console.log("type 2");
            return [
                m, h, 
                [m.toString(), 'minutter over', h.toString()]
            ];
        
        case 3:
            console.log("type 3");
            return [
                m + 30, h, 
                [Math.abs(m - 30).toString(), 'minutter i', (h < 12) ? (h + 1).toString() : (1).toString()]
            ];

        default:
            console.log("Error in challenge.js");
            break;
    }
    */ 






(0, $3555ff9e1e0fa800$export$bed6ab87e2e89fc)();
const $fcd6031be73b1372$var$level = (0, $3555ff9e1e0fa800$export$bbb5699fb5728e4f)();
let $fcd6031be73b1372$var$difficulty = {
    fiveMinutesInterval: $fcd6031be73b1372$var$level > 1 ? false : true,
    clockType: $fcd6031be73b1372$var$level > 2 ? 'digital' : 'analog'
};
let $fcd6031be73b1372$var$challenge = (0, $5832402495609784$export$4e9f46eab2f1407a)($fcd6031be73b1372$var$difficulty);
console.log($fcd6031be73b1372$var$challenge);
(0, $a2b1af726bc05dc6$export$4a17d052f4e372b2)($fcd6031be73b1372$var$challenge.h, $fcd6031be73b1372$var$challenge.m, 0, $fcd6031be73b1372$var$difficulty.clockType);
(0, $d560f046f37f5b87$export$34d72cd9c2e466e5)($fcd6031be73b1372$var$challenge.solution, $fcd6031be73b1372$var$challenge.wrong, (0, $5832402495609784$export$e230fdca65f21805));
function $fcd6031be73b1372$export$2d6e9b4c68afb6c8() {
    location.reload();
}


//# sourceMappingURL=watch-me-play.0b444710.js.map
